import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { catchError, map, switchMap, of } from 'rxjs';
import { environment } from '../../../environment/environment';

export function update_template(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const templateId = data.template_id;
  if (!templateId) {
    throw new Error('Manglende skabelon-id');
  }

  const templatePayload = {
    name: data.name,
    description: data.description || '',
    visibility: data.visibility || 'private',
    template_data: data.template_data || {}
  };

  const request$ = componentDataDestService.http
    .put(`${environment.apiUrl}/duna_templates/${templateId}`, templatePayload)
    .pipe(
      catchError((error) => {
        console.error('[update_template] Error:', error);
        throw error;
      }),
      switchMap((response) =>
        componentDataSourceService.updateStoreData(of(response), 'templates').pipe(
          map(() => response)
        )
      )
    );

  return request$;
}
